import RetailerService from '../services/RetailerService';
import { Retailer } from '../models';
const APP_STORAGE_KEY_RETAILER = 'OMNI_WEBAPP_RETAILER';

export interface RetailerState {
  retailer: Retailer;
}

export const RetailerModule = {
  state: {
    retailer: window.localStorage.getItem(APP_STORAGE_KEY_RETAILER) &&
      JSON.parse(window.localStorage.getItem(APP_STORAGE_KEY_RETAILER) as any) || {},
  },
  mutations: {
    setRetailer(state: any, retailer: any) {
      if (retailer) {
        window.localStorage.setItem(APP_STORAGE_KEY_RETAILER, JSON.stringify(retailer));
      } else {
        window.localStorage.removeItem(APP_STORAGE_KEY_RETAILER);
      }
      state.retailer = retailer;
    },
  },
  actions: {
    loadRetailer({commit}: any): Promise<any> {
      return RetailerService.getRetailer().then((res) => {
        return res && res.length && res[0] || null;
      }).then((retailer) => {
        commit('setRetailer', retailer);
        return retailer;
      });
    },
  },
};
